'use client';
import { PlaneIcon } from '@c/icons';
import { useAuth } from 'context/AuthContext';
import Link from 'next/link';

const DashboardLayoutBanners = () => {
  const { user, userDoc } = useAuth();
  return user && user.isAnonymous ? (
    <div className="text-white-800 flex h-[4.8rem] w-full items-center justify-center bg-red-100">
      <Link
        className="flex items-center gap-[0.8rem] text-[1.4rem] font-medium underline"
        href="/verify-phone"
      >
        Click here to finish creating your account
      </Link>
    </div>
  ) : user && !user.emailVerified ? (
    <div className="text-white-800 flex h-[4.8rem] w-full items-center justify-center bg-red-100">
      <Link
        className="flex items-center gap-[0.8rem] text-[1.4rem] font-medium underline"
        href="/verify-email"
      >
        Please verify your email address.
      </Link>
    </div>
  ) : userDoc?.stripe_requirements?.length && !userDoc.roles?.admin ? (
    <div className="flex h-[4.8rem] w-full items-center justify-center bg-yellow-100 text-yellow-800">
      <Link
        className="flex items-center gap-[0.8rem] text-[1.4rem] font-medium underline"
        href="/dashboard/shop-settings"
      >
        Your seller account requires more info. Please complete it on the shop
        settings page.
      </Link>
    </div>
  ) : userDoc?.on_vacation ? (
    <div className="flex h-[4.8rem] w-full items-center justify-center gap-[1.6rem] bg-brand-secondary text-[1.8rem] text-white">
      <PlaneIcon />
      Your account is currently in vacation mode.
    </div>
  ) : null;
};

export default DashboardLayoutBanners;
